import React, { FC } from 'react'
import { Box } from '../Layout'
import { ConfirmationProps } from '.'
import * as S from './elements'
import Link from '../Link'
import { Text } from '../Typography'
import { rem } from 'polished'

const Confirmation: FC<ConfirmationProps> = ({
  description,
  label,
  sublabel,
  onClickAction,
  actionLabel
}) => {
  return (
    <Box
      display="grid"
      gridTemplateColumns={
        actionLabel
          ? [`${rem(40)} auto auto`, `${rem(56)} auto auto`]
          : [`${rem(40)} auto`, `${rem(56)} auto`]
      }
      gridColumnGap={['.75rem', '1rem']}
      alignItems="center"
    >
      <S.Icon icon="check"></S.Icon>

      <Box overflow="hidden">
        <Text variant="micro" as="div" mb={[1, rem(3)]}>
          {description}
        </Text>
        <S.Label mb={0} width="100%">
          <b>{label}</b>
          {sublabel && ' • '}
          {sublabel}
        </S.Label>
      </Box>
      {actionLabel && (
        <Box display="flex" justifyContent="flex-end">
          <Link as="button" variant="grey" onClick={onClickAction}>
            {actionLabel}
          </Link>
        </Box>
      )}
    </Box>
  )
}

export default Confirmation
